'use strict';

/**
 * Local storage wrapper (for tests mainly)
 */
export default {
  getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {}
  },

  setItem(key, value) {
    try {
      return window.localStorage.setItem(key, value);
    } catch (e) {}
  }
};



// WEBPACK FOOTER //
// ./storage/storage.js